export { Property, type Props } from './index.pc'
export { MobileProperty } from './index.mobile'
